import {useSelector} from "react-redux";
import {Button, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel, faSpinner} from "@fortawesome/free-solid-svg-icons";
import React, {cloneElement, Fragment, useEffect, useState} from 'react';
import {selectLang} from "../../../store/reducers/main/main";
import {Translate} from "../../../lang/lang";
import {downloadFile} from "../../../helpers/excel-uploader";
import {TYPE_TRANSFER} from "../../../enum/excel/ExcelTemplateTypes";
import {selectOrganizationTemplates, uploadTransferToExcelAsync} from "../../../store/reducers/excel/excelReducer";
import IconButton from "../../../components/IconButton";

const UploadTransferToExcel = ({id, number, children, ...props}) => {
    const [transferTypeTemplates, setTransferTypeTemplates] = useState([]);
    const organizationTemplates = useSelector(selectOrganizationTemplates);
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    useEffect(() => {
        const templates = organizationTemplates.filter(template => template.type === TYPE_TRANSFER) || [];
        setTransferTypeTemplates(templates);
    }, [organizationTemplates])

    const uploadTransfer = (uri) => {
        setLoading(true);
        uploadTransferToExcelAsync({uri: uri, id: id})
            .then(({content, contentType}) => {
                downloadFile({
                    content: content,
                    contentType: contentType,
                    fileName: t(lang, 'warehouse.item.download_excel.transfer_name', {number: number}),
                });
            })
            .catch((error) => console.log("error", error))
            .finally(() => setLoading(false))
    }

    return (
        <Fragment>
            {transferTypeTemplates.length > 1
                ?
                <Dropdown {...props}>
                    <Dropdown.Toggle bsPrefix="toggle" variant="falcon-default" size="sm" disabled={loading}>
                        {!!children
                            ?
                            <div>
                                {!!loading && <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>}
                                {!loading && cloneElement(children, {...children.props})}
                            </div>
                            :
                            <div>
                                {loading
                                    ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                                    : <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                                }
                                <span className="d-none d-sm-inline-block">
                                    {t(lang, 'warehouse.operation.item.common.download_excel')}
                                </span>
                            </div>
                        }
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='py-2'>
                        {transferTypeTemplates.map((template, index) => (
                            <Dropdown.Item key={index} onClick={() => uploadTransfer(template.uri)}>
                                {t(lang, 'main.common.file.upload.template_name.prefix', {template_name: t(lang, `common.excel.template.name.${template.name}`)})}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                :
                <Fragment>
                    {!!children
                        ?
                        <Button variant="falcon-default" size="sm" disabled={loading} {...props} onClick={() => {
                            const [defaultTemplate] = transferTypeTemplates;
                            uploadTransfer(defaultTemplate.uri);
                        }}>
                            {cloneElement(children, {...children.props})}
                        </Button>
                        :
                        <IconButton {...props} variant='phoenix-warning' size="sm" disabled={loading} onClick={() => {
                            const [defaultTemplate] = transferTypeTemplates;
                            uploadTransfer(defaultTemplate.uri);
                        }}
                                    className={'btn-davr bg-white text-dark d-flex gap-2'}
                                    iconClassName={"text-primary-davr fs-8"}
                        >
                            {loading
                                ? <FontAwesomeIcon className="me-1 fs-7 text-primary-davr" pulse={true} icon={faSpinner}/>
                                : <FontAwesomeIcon className="me-1 fs-7 text-primary-davr" icon={faFileExcel}/>
                            }

                            <span
                                className="d-none d-sm-inline-block">{t(lang, 'warehouse.operation.item.common.download_excel')}</span>
                        </IconButton>
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export default UploadTransferToExcel;